"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = exports.CategoryBanner = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _classnames = _interopRequireDefault(require("classnames"));

require("./CategoryBanner.scss");

var cssAnchorName = 'category-banner';
exports.cssAnchorName = cssAnchorName;

var CategoryBanner = function CategoryBanner(_ref) {
  var _bannerConfig$title, _bannerConfig$button, _bannerConfig$button$2, _bannerConfig$button2;

  var categoryTitle = _ref.categoryTitle,
      categoryImage = _ref.categoryImage,
      bannerConfig = _ref.bannerConfig,
      attachmentCdn = _ref.attachmentCdn;

  // Don't render if banner is not enabled
  if (!(bannerConfig !== null && bannerConfig !== void 0 && bannerConfig.enabled)) {
    return null;
  } // Use custom title/image if set, otherwise fallback to category defaults


  var displayTitle = (_bannerConfig$title = bannerConfig.title) !== null && _bannerConfig$title !== void 0 ? _bannerConfig$title : categoryTitle;
  var displayImage = bannerConfig.image ? attachmentCdn + bannerConfig.image : categoryImage; // Get button text - handle both string and translation object

  var buttonText = '';

  if ((_bannerConfig$button = bannerConfig.button) !== null && _bannerConfig$button !== void 0 && _bannerConfig$button.text) {
    if (typeof bannerConfig.button.text === 'string') {
      buttonText = bannerConfig.button.text;
    } else {
      var _ref2, _bannerConfig$button$;

      buttonText = (_ref2 = (_bannerConfig$button$ = bannerConfig.button.text.en) !== null && _bannerConfig$button$ !== void 0 ? _bannerConfig$button$ : Object.values(bannerConfig.button.text)[0]) !== null && _ref2 !== void 0 ? _ref2 : '';
    }
  }

  var buttonUrl = (_bannerConfig$button$2 = (_bannerConfig$button2 = bannerConfig.button) === null || _bannerConfig$button2 === void 0 ? void 0 : _bannerConfig$button2.url) !== null && _bannerConfig$button$2 !== void 0 ? _bannerConfig$button$2 : '';
  return (0, _preact.h)("div", {
    className: "category-banner"
  }, (0, _preact.h)("div", {
    className: "category-banner__lockup"
  }, displayImage && (0, _preact.h)("img", {
    src: (0, _absoluteUrlRuntime.resolveUrl)(displayImage),
    alt: "",
    className: "category-banner__image"
  }), (0, _preact.h)("span", {
    className: "category-banner__title"
  }, displayTitle)), buttonText && buttonUrl && (0, _preact.h)("a", {
    href: (0, _absoluteUrlRuntime.resolveUrl)(buttonUrl),
    className: (0, _classnames.default)('btn', 'btn--secondary', 'btn--S'),
    target: "_blank",
    rel: "noopener noreferrer"
  }, buttonText));
};

exports.CategoryBanner = CategoryBanner;
var _default = CategoryBanner;
exports.default = _default;